import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/player.png'
import _imports_1 from '@/assets/image/icon/pause.png'


const _withScopeId = n => (_pushScopeId("data-v-35705790"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  class: "no-event",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no-event pause-icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { ref, onMounted, onBeforeUnmount } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: ['src', 'post'],
  setup(__props) {



const videoPlay = ref()
const focus = ref(false)
const pausing = ref(true)

const play = () => {
  videoPlay.value.play()
  pausing.value = false
  focus.value = false
}

const pause = () => {
  videoPlay.value.pause()
  pausing.value = true
}

const listener = () => {
  pausing.value = true
}
onMounted(() => {
  videoPlay.value.addEventListener('ended', listener)
})
onBeforeUnmount(() => {
  videoPlay.value.removeEventListener('ended', listener)
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "rel wrap",
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (!pausing.value && (focus.value = true))),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (focus.value = false))
  }, [
    _createElementVNode("video", {
      src: __props.src,
      ref: (_value, _refs) => {
        _refs['videoPlay'] = _value
        videoPlay.value = _value
      }
    }, null, 8, _hoisted_1),
    _withDirectives(_createElementVNode("div", {
      class: "btn play-btn flex-center",
      onClick: play
    }, _hoisted_3, 512), [
      [_vShow, pausing.value]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "btn play-btn flex-center",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (pause()))
    }, _hoisted_5, 512), [
      [_vShow, focus.value && !pausing.value]
    ])
  ], 544)), [
    [_vShow, __props.src]
  ])
}
}

})